import { useTheme } from '../theme/ThemeContext';

interface LogoProps {
  /** login = large lockup, sidebar = compact lockup, mark = square icon only */
  variant?: 'login' | 'sidebar' | 'mark';
  /**
   * Which surface the mark is sitting on.
   *
   * `brand` is the master artwork. `onDark` is the same lockup tuned for a dark
   * field: the yellow is untouched, the dark greens are lifted in lightness
   * (same hue) so they read on navy, and the near-black tagline is white. It
   * lets the sidebar and the sign-in hero carry the brand colours without
   * parking the logo on a white plate.
   */
  tone?: 'brand' | 'onDark' | 'auto';
  className?: string;
}

/**
 * The SkillXzen brand lockup.
 *
 * One component so the asset paths and alt text are defined once; if the brand
 * files are replaced, nothing else has to change.
 */
export function Logo({ variant = 'sidebar', tone = 'brand', className }: LogoProps) {
  // `auto` is for surfaces that follow the theme (the public header, the
  // sign-in card): dark mode makes them dark, where the master artwork's
  // deep green and near-black tagline would all but disappear.
  const { theme } = useTheme();
  const onDark = tone === 'onDark' || (tone === 'auto' && theme === 'dark');
  return (
    <img
      src={onDark ? '/brand/skillxzen-logo-light.png' : '/brand/skillxzen-logo.png'}
      alt="SkillXzen — Industry Ready"
      className={`sx-logo sx-logo--${variant}${className ? ` ${className}` : ''}`}
    />
  );
}
